<template>
    <b-card no-body class="mb-0 border-warning">
        <h4 class="px-1 py-75 mb-0">Depo Onayı Bekleyen Transferler</h4>
        <FuelTransferConfirmModal ref="confirmModal" @confirm="handleTransferConfirmation" />
        <v-table ref="table" :items-provider="provider" :fields="fields" :buttons="buttons" :settings="false" empty-text="Onay bekleyen transfer bulunmamaktadır."> </v-table>
    </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import FuelStorageApi from "@/api/fuel-storage";
import FuelTransferConfirmModal from "../../fuel-storage/components/FuelTransferConfirmModal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
    name: "FuelTransferWaitingMyApprove",
    components: {
        BCard,
        FuelTransferConfirmModal,
    },
    data() {
        return {
            loading: false,
            buttons: [{ text: "Onayla", key: "approve", icon: "CheckCircleIcon", variant: "success", action: this.approve }],
            fields: [
                { name: "İşlem No", key: "ProcessNumber", thClass: "text-nowrap w-20", tdClass: "text-nowrap w-20" },
                { name: "Hedef Şube", key: "TargetBranchName", thClass: "text-nowrap w-20", tdClass: "text-nowrap w-20" },
                { name: "Araç", key: "VehiclePlate", thClass: "text-nowrap w-15", tdClass: "text-nowrap w-15" },
                { name: "Sürücü", key: "CarrierFullName", thClass: "text-nowrap w-25", tdClass: "text-nowrap w-25" },
                { name: "Miktar [lt]", key: "Quantity", thClass: "text-nowrap vt-th-text-right w-20", tdClass: "text-nowrap text-right w-20" },
            ],
        };
    },
    methods: {
        provider(data) {
            return FuelStorageApi.FuelStorageTransaction.GetListWaitingMyConfirm()
                .then((res) => {
                    if (res && res.data && res.data.Success) {
                        return res;
                    }
                    if (res && res.data) res.data.Data = [];
                    return res;
                })
                .catch((err) => {
                    console.error("Transfer Listesi Yüklenemedi:", err);
                    return {
                        data: {
                            Success: false,
                            Data: [],
                            Message: "Veri yüklenirken hata oluştu.",
                        },
                    };
                });
        },
        approve(d) {
            const detailObj = {
                Id: d.Id,
                FuelStorageName: d.FuelStorage,
                TargetBranchName: d.TargetBranchName,
                Quantity: d.Quantity,
                ProcessNumber: d.ProcessNumber,
            };

            // Onay modalı "Transfer Özeti" panelinde kaynak depo/tonaj/fişi gösteriyor;
            // backend artık bu bilgileri SourceFuelStorageName / SourceTonnage / SourceQuantity
            // alanlarında döndüğü için sourceDetail olarak inject ediyoruz.
            const sourceDetail = {
                FuelStorageName: d.SourceFuelStorageName,
                Tonnage: d.SourceTonnage,
                Quantity: d.SourceQuantity,
                File: d.SourceFile || null,
            };

            this.$refs.confirmModal.open(detailObj, sourceDetail, d.ProcessNumber, d.FuelTypeName || null, d.TargetBranchId);
        },

        handleTransferConfirmation(data) {
            const formData = new FormData();
            formData.append("FuelStorageTransferTransactionDetailId", data.id);
            formData.append("Tonnage", String(data.Tonnage).replace(".", ","));
            formData.append("Density", String(data.Density).replace(".", ","));
            formData.append("ConfirmQuantity", String(data.ConfirmQuantity).replace(".", ","));

            if (data.File) {
                formData.append("File", data.File);
            }

            if (data.FuelStorageId) {
                formData.append("FuelStorageId", data.FuelStorageId);
            }

            if (this.$refs.table.rowLoading) this.$refs.table.rowLoading(true);

            FuelStorageApi.FuelStorageTransaction.ConfirmTransfer(formData)
                .then((res) => {
                    if (res.data.Success) {
                        this.$toast({
                            component: ToastificationContent,
                            props: { title: "Başarılı", icon: "CheckCircleIcon", variant: "success", text: "Transfer başarıyla onaylandı." },
                        });
                        this.$refs.table.refresh();
                        this.$refs.confirmModal.hide();
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            props: { title: "Hata", icon: "AlertCircleIcon", variant: "danger", text: res.data.Message || "İşlem başarısız." },
                        });
                        this.$refs.confirmModal.loading = false;
                    }
                })
                .catch((err) => {
                    this.$toast({
                        component: ToastificationContent,
                        props: { title: "Hata", icon: "AlertCircleIcon", variant: "danger", text: "Sunucu hatası oluştu." },
                    });
                    this.$refs.confirmModal.loading = false;
                })
                .finally(() => {
                    if (this.$refs.table.rowLoading) this.$refs.table.rowLoading(false);
                });
        },
    },
};
</script>
